import React from 'react';
import { Controller } from 'react-hook-form';
import { Radio, Space } from 'antd';
import Span from 'src/components/ui/Span';
import { useTranslation } from 'react-i18next';
import { getFormLabel, getFormOptionsWithEnglishValues, getFormInstructions } from 'src/helpers/multilingualHelper';

const SingleSelectClientForm = ({ elementId, label, name, required, options, control, errors, config, onChange, value }) => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language || 'en';

    const displayLabel = getFormLabel(label, currentLanguage);
    const displayOptions = getFormOptionsWithEnglishValues(options, currentLanguage);
    const displayInstructions = getFormInstructions(config?.instructions, currentLanguage);
    const hasError = !!errors[elementId];

    return (
        <div className="relative inline-block w-full">
            <label htmlFor={elementId} className={`block ${config.hasInstructions ? '' : 'mb-2'} text-sm  text-gray-700`}>
                {displayLabel}{required && '*'}
            </label>
            {config.hasInstructions && (
                <label className="mb-2 text-xs  text-gray-300">
                    {displayInstructions}
                </label>
            )}
            <Controller
                name={name || elementId}
                control={control}
                rules={{ required }}
                render={({ field }) => {
                    if (!field.value && value) {
                        field.onChange(value);
                    }

                    const effectiveValue = field.value || value;

                    return (
                        <Radio.Group
                            id={elementId}
                            value={effectiveValue}
                            onChange={(e) => {
                                field.onChange(e.target.value);
                                onChange && onChange(elementId, e);
                            }}
                            className="w-full"
                        >
                            <Space direction="vertical">
                                {displayOptions.map((option, index) => (
                                    <Radio key={index} value={option.value}>
                                        {option.label}
                                    </Radio>
                                ))}
                            </Space>
                        </Radio.Group>
                    );
                }}
            />
            {hasError && (
                <Span className="text-FailRed400 text-xxs">
                    {errors[elementId].message ? errors[elementId].message : t('form.thisFieldRequired')}
                </Span>
            )}
        </div>
    );
};

export default SingleSelectClientForm;
